import $ from 'jquery';
import {onImgLoad} from '../lib/utils.js';

export default class DetailedFloorPlan {
  constructor(options) {
    if (!options.el || !options.contents) return;
    this.el = options.el;
    this.contents = options.contents;

    // this.closeBtn = this.el.querySelector('.c-floorplan__close');
    this.download = this.el.querySelector('.c-floorplan__download');
    this.detailedImage = this.el.querySelector('.c-floorplan__detailed-img');
    this.detailedContent = this.el.querySelector('.c-floorplan__detailed-content');
    this.detailedWrapper = this.el.querySelector('.c-floorplan__detailed-wrapper');

    this.listen();

    // console.dir(this);
  }

  listen() {
    this.download.addEventListener('click', e => {
      e.stopPropagation();
    });

    // this.closeBtn.addEventListener('click', e => {
    //   e.stopPropagation();
    //   this.closeDetailedFloorPlan();
    // })
  }

  getFloorplanID() {
    return this.el.getAttribute('data-floorplan-id');
  }

  addActive() {
    if (!$(this.el).hasClass('active')) {
      this.el.style.maxHeight = `${this.detailedWrapper.scrollHeight}px`;
      $(this.el).addClass('active');
    }
  }

  removeActive() {
    $(this.el).removeClass('active');
    this.el.style.maxHeight = '';
  }

  closeDetailedFloorPlan() {
    this.removeActive();

    // setTimeout(() => {
      this.resetDetailedFloorPlan();
    // }, 500);
  }

  resetDetailedFloorPlan() {
    this.el.removeAttribute('data-floorplan-id');
    this.download.removeAttribute('href');
    this.emptyChild(this.detailedImage);
    this.emptyChild(this.detailedContent);
  }

  showDetailedFloorPlan(areaEl) {
    var imgUrl = areaEl.getAttribute('data-floorplan-img');
    var pdfUrl = areaEl.getAttribute('data-floorplan-pdf');
    var areaID = areaEl.getAttribute('data-target-id');
    var content = this.contents.querySelector(`[data-floorplan-content=${areaID}]`);

    if (imgUrl) {
      var self = this;
      var floorPlanImg = new Image();
      floorPlanImg.src = imgUrl;

      onImgLoad(floorPlanImg, function() {
        self.el.setAttribute('data-floorplan-id', areaID);
        self.download.setAttribute('href', pdfUrl);
        self.detailedImage.appendChild(floorPlanImg);
        self.detailedContent.innerHTML = (content) ? content.innerHTML : '';
        self.addActive();
        self.scrollIntoView();
      });
    }
  }

  show(areaEl) {
    var clickID = areaEl.getAttribute('data-target-id');

    if ($(this.el).hasClass('active')) {
      if (clickID === this.getFloorplanID()) {
        this.closeDetailedFloorPlan();
      } else {
        this.closeDetailedFloorPlan();
        // setTimeout(() => {
          this.showDetailedFloorPlan(areaEl);
        // }, 500);
      }
    } else {
      this.showDetailedFloorPlan(areaEl);
    }
  }

  scrollIntoView() {
    var offset = 50;
    var offsetBtm = this.el.getBoundingClientRect().top + this.el.scrollHeight + offset;
    var screenHeight = window.innerHeight;

    $('html, body').animate({
      scrollTop: window.pageYOffset + (offsetBtm - screenHeight)
    }, 300);
  }

  emptyChild(el) {
    while (el.lastChild) {
      el.removeChild(el.lastChild);
    }
  }

}
